import { render, staticRenderFns } from "./GlobalPackageSummary.vue?vue&type=template&id=aa92314e&"
import script from "./GlobalPackageSummary.vue?vue&type=script&lang=js&"
export * from "./GlobalPackageSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports